module.exports = __webpack_public_path__ + "img/201.90f64749.png";